<template>
  <div class="price-content">
    <search-box class="search-box">
      <el-form :inline="true" size="mini" label-width="80px" :model="searchForm" :rules="rules" ref="searchForm">
        <el-form-item label="店铺名称" prop="storeCode">
          <el-select v-model="searchForm.storeCode" multiple collapse-tags clearable style="width: 240px">
            <el-option v-for="item in storeList" :key="item.storeCode" :label="item.shortName" :value="item.storeCode"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品编码" prop="skuCode">
          <el-input v-model="searchForm.skuCode" @keyup.enter.native="onSearch"></el-input>
        </el-form-item>
        <el-form-item label="商品名称" prop="skuName">
          <el-input v-model="searchForm.skuName" @keyup.enter.native="onSearch"></el-input>
        </el-form-item>
        <el-form-item label="调整类型" prop="adjustType">
          <el-select v-model="searchForm.adjustType" clearable multiple collapse-tags>
            <el-option label="实际执行价格" value="实际执行价格"></el-option>
            <el-option label="分类" value="分类"></el-option>
            <el-option label="一段红包" value="一段红包"></el-option>
            <el-option label="二段红包" value="二段红包"></el-option>
            <el-option label="三段红包" value="三段红包"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="处理结果" prop="status">
          <el-select v-model="searchForm.status" clearable multiple collapse-tags>
            <el-option label="待处理" :value="0"></el-option>
            <el-option label="已处理" :value="1"></el-option>
            <el-option label="未上架" :value="2"></el-option>
            <el-option label="暂缓处理" :value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="调整备注" prop="adjustRemark">
          <el-input v-model="searchForm.adjustRemark" @keyup.enter.native="onSearch"></el-input>
        </el-form-item>
        <el-form-item label="通知时间">
          <form-date-range
            :form="searchForm"
            startKey="dts"
            endKey="dte"
            :usingTime="false"
            valueFormat="yyyy-MM-dd"
          ></form-date-range>
        </el-form-item>
      </el-form>
      <template v-slot:right>
        <el-button class="green-btn" size="mini" @click="onSearch">搜索</el-button>
        <el-button class="orange-btn" size="mini" @click="onReset">重置</el-button>
      </template>
    </search-box>

    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" size="mini" @click="exportExcel">导出</el-button>
      </template>
      <el-table stripe border ref="tableRef" :data="tableData.list" :height="maxTableHeight" v-if="tableReload" v-loading="loading">
        <el-table-column prop="skuCode" label="商品编码" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="skuName" label="商品名称" min-width="200" show-overflow-tooltip></el-table-column>
        <el-table-column prop="storeName" label="店铺名称" min-width="80" show-overflow-tooltip></el-table-column>
        <el-table-column prop="userName" label="负责人" min-width="200" show-overflow-tooltip></el-table-column>
        <el-table-column prop="adjustType" label="调整类型" min-width="90" show-overflow-tooltip></el-table-column>
        <el-table-column prop="emergency" label="紧急程度" min-width="80" show-overflow-tooltip></el-table-column>
        <el-table-column prop="adjustBefore" label="调整前" min-width="80" show-overflow-tooltip></el-table-column>
        <el-table-column prop="adjustAfter" label="调整后" min-width="80" show-overflow-tooltip></el-table-column>
        <el-table-column prop="adjustRemark" label="调整备注" min-width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="result" label="处理结果" min-width="80" show-overflow-tooltip></el-table-column>
        <el-table-column prop="operationName" label="操作人" min-width="80" show-overflow-tooltip></el-table-column>
        <el-table-column prop="lastUpdateDate" label="操作时间" min-width="150" show-overflow-tooltip></el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 60, 90]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="tableData.total"
          ></el-pagination>
        </div>
      </template>
    </table-panel>
  </div>
</template>

<script>
import tableMixin from '@/utils/tableMixin';
import pagePathMixin from '@/utils/page-path-mixin';
import moment from 'moment';

export default {
  name: 'PriceContent',
  mixins: [tableMixin, pagePathMixin],
  props: {
    detailParams: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      tableReload: true,
      searchFormData: [],
      rules: {},
      storeList: [],
      searchForm: {
        storeCode: '',
        adjustType: [],
        status: [],
        adjustRemark: '',
        skuCode: '',
        skuName: '',
        dts: moment().subtract(3, 'month').format('YYYY-MM-DD'),
        dte: moment().format('YYYY-MM-DD'),
      },
      // 店铺标签页
      activeTab: undefined,
      storeTabs: [],
    };
  },
  mounted() {
    let query = this.$route.query;
    if (query.dts && query.dte) {
      this.searchForm.dts = query.dts;
      this.searchForm.dte = query.dte;
    }
    let newVal = this.detailParams;
    if (newVal && newVal.type === 1) {
      this.searchForm.storeCode = newVal.storeCode ? [newVal.storeCode] : [];
      this.searchForm.adjustType = newVal.adjustType ? [newVal.adjustType] : [];
      this.onSearch();
    }

    this.getStoreList();
    this.onSearch();
  },
  methods: {
    handleTabClick() {
      this.onSearch();
    },

    onSearch() {
      this.tableData.pageNum = 1;
      this.init();
    },

    async init() {
      this.loading = true;
      let { skuCodes, adjustType } = this.searchForm;
      let data = {
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
        filterData: {
          ...this.searchForm,
          type: 1,
        },
      };
      this.searchFormData = data;
      this.$q.newProduct
        .onSaleUpdatePageItem({ data: data })
        .then(res => {
          if (res.code == 200) {
            this.tableData = res.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init();
    },

    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init();
    },

    onReset() {
      this.$refs.searchForm.resetFields();
      this.tableData.pageNum = 1;
      this.onSearch();
    },

    getStoreList() {
      let data = {
        pageNum: 1,
        pageSize: 999999,
        filterData: {
          newArrival: 1,
        },
      };
      this.$q.configurationCenter.storeManagePage({ data: data }).then(res => {
        if (res.code == 200) {
          this.storeList = res.data.list;
        }
      });
    },

    // 导出
    exportExcel() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      let params = {
        appCode: 'ec-pc-api',
        paramMap: {
          ...this.searchFormData.filterData,
        },
        reportName: 'priceUpdate',
      };
      this.$q.common.exportExcel({ data: params }).then(res => {
        if (res.success) {
          this.$message.success('提交下载任务成功，请稍后到导出列表查阅！');
          loading.close();
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.price-content {
  >>> .search-outer>div {
    padding: 0;
  }
}

.search-box {
  >>> .el-date-editor.el-input__inner, >>> .el-select, >>> .el-input {
    width: 240px !important;
  }
}

.tabs-row {
  margin-bottom: 5px;
}

.tabs {
  >>> .el-tabs__header {
    margin: 0 !important;
  }
}

.occupy {
  width: 200px;
  height: 20px
}

.table-btn-area {
  text-align: right;
  line-height: 40px;
}

.search-box
  >>> .el-date-editor.el-input__inner, >>> .el-select, >>> .el-input
      width 240px !important
  >>> .date-range .single-date
    width 110px !important

  >>> .form-number-input .el-input-number {
      width: 105px !important;
  }
  >>> .form-number-input .el-input-number .el-input {
      width: 105px !important;
  }
</style>
